module.exports = __webpack_public_path__ + "img/gift1-be.72f3dd71.jpg";